import Ajax from '@utils/ajax';

export default {
  create(url, groupId, options = {}) {
    return Ajax.post({
      url: `/affiliate_links`,
      data: { url: url, group_base_id: groupId },
      ...options,
    });
  },

  get(responseId, options = {}) {
    return Ajax.get({
      url: `/affiliate_links/${responseId}`,
      ...options,
    });
  },

  createVisit(affiliateId, options = {}) {
    return Ajax.post({
      url: `/affiliate_links/${affiliateId}/affiliate_link_visits`,
      ...options,
    });
  },

  convertLinksToAffiliate(regex, options = {}) {
    return Ajax.post({
      url: `/affiliate_links/convert_links_to_affiliate`,
      data: { regex: regex },
      ...options,
    });
  },
};
